// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3LVZ1","actionsCol":"EnrolledClinics_actionsCol__e5bd8"};